import { render, staticRenderFns } from "./CampaignCouponForm.vue?vue&type=template&id=640edf59"
import script from "./CampaignCouponForm.vue?vue&type=script&lang=js"
export * from "./CampaignCouponForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports